module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/version.js
// module id = 9
// module chunks = 0